import { request } from './client';

export interface RedirectUrl {
  /// Stripe-hosted URL to navigate to (`window.location = url`).
  url: string;
}

export type PlanInterval = 'monthly' | 'annual';

/// Start Stripe Checkout for the chosen term. The server creates the session
/// and returns a hosted URL the panel navigates to. Non-idempotent (creates a
/// Checkout Session) → `noRetry`.
export function startCheckout(interval: PlanInterval): Promise<RedirectUrl> {
  return request<RedirectUrl>('/billing/checkout', {
    method: 'POST',
    body: { interval },
    noRetry: true,
  });
}

/// Open the Stripe Customer Portal; the server returns a hosted URL.
export function openPortal(): Promise<RedirectUrl> {
  return request<RedirectUrl>('/billing/portal', {
    method: 'POST',
    body: {},
    noRetry: true,
  });
}
